// Rafal Template

import "../sass/rafal3.scss";
import "./hero.animation.js";

console.log("This is the rafal3!");
